import React from 'react'
import styled from 'styled-components';
import ListBoxPiece from './ListBoxPiece'

const ListBoxStyle = styled.div`
  margin: 40px -20px 30px 0;
  display: inline-flex;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    margin: 20px 0 20px 0;
    display: block;
  }
`;

export default function ListBox() {
  return (
    <ListBoxStyle>
      <ListBoxPiece></ListBoxPiece>
      <ListBoxPiece></ListBoxPiece>
      <ListBoxPiece></ListBoxPiece>
      <ListBoxPiece></ListBoxPiece>
      <ListBoxPiece></ListBoxPiece>
    </ListBoxStyle>
  )
}
